import { TableDataChartComponent } from '../charts/table-data-chart-component'
import { topSubreddits } from '../commons/data-placeholder'

export class AFTopSubreddits extends TableDataChartComponent {
 static config = {
  selector: 'afTopSubreddits',
  controller: AFTopSubreddits,
  bindings: TableDataChartComponent.config.bindings,
  template: TableDataChartComponent.config.template,
 }

 public csvHeaders = ['Subreddits', 'Mentions', 'Subreddit URL']
 vizData = topSubreddits

 buildTableDataOptions() {
  return ['Subreddits', 'explore__visualizations--key-metrics-mentions']
 }
 buildTableDataChartData(data) {
  // calculate indexes for pagination
  let startIndex = this.pagination.currentPage * this.pagination.pageSize
  let endIndex = this.pagination.currentPage * this.pagination.pageSize + this.pagination.pageSize
  return data.slice(startIndex, endIndex).map(x => ({
   ...x,
   imageSource: 'mediatypes:reddit_color_round',
   haloColor: '#FF4500',
  }))
 }
}
